<template>
  <div>
    <img
      class="absolute top-0 right-0 w-full select-none"
      style="z-index: -1"
      draggable="false"
      :src="$cdnBaseUrl + '/img/graphics/dashboard-gradient.png'"
    />
  </div>
  <div>
    <router-view />
  </div>
</template>

<script setup></script>
